import * as React from 'react';

// Material-UI
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField'

import {
  PriorityPeriod
} from '../models';

interface PriorityPeriodListProps {
  disabled: boolean;
  endDate?: string;
  handlePriorityPeriodChange: (period: PriorityPeriod) => void;
  priorityPeriods: Array<PriorityPeriod>;
  reset: boolean;
}

const PriorityPeriodList: React.FC<PriorityPeriodListProps> = (props: PriorityPeriodListProps) => {

  const [period, setPeriod] = React.useState<PriorityPeriod | undefined>();

  // #region Styles

  const styles = {
    selectWidth: {
      minWidth: 350,
    },
  };

  // #endregion

  // #region Methods

  /*
 * Reset selected priority period
 */
  const resetSelectedPeriod = () => {
    setPeriod(undefined);
  }

  // #endregion

  // #region Event handlers

  /*
   * Handler for change in selected signup weekend
   */
  const handlePriorityPeriodChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedPeriod = props.priorityPeriods.find((p: PriorityPeriod) => {
      return (p.priorityPeriodID === Number(event.target.value));
    });
    if (selectedPeriod) {
      setPeriod(selectedPeriod);
      props.handlePriorityPeriodChange(selectedPeriod);
    }
  };

  React.useEffect(() => {
    resetSelectedPeriod();
  }, [props.reset]);

  // #endregion

  return (
    <TextField
      select
      label='Weekend/Holiday Dates'
      sx={styles.selectWidth}
      disabled={props.disabled}
      onChange={handlePriorityPeriodChange}
      value={period ? period.priorityPeriodID.toString() : '0'}
    >
      <MenuItem key={0} value={0}>Select dates to fill arrival/departure</MenuItem>
      {props.priorityPeriods.map((period: PriorityPeriod) => (
        <MenuItem key={period.priorityPeriodID} value={period.priorityPeriodID}>{period.arrivalDate + ' to ' + period.departureDate + (period.description ? ' ' + period.description : '')}</MenuItem>
      ))}
    </TextField>
  );

}

export default PriorityPeriodList;